import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Label, Input } from "reactstrap";
import { useLoader } from "../../_helper/LoaderContext";
import { useLab } from "../../_helper/PharmacyProvider";
import { paymentIn, paymentOut } from "./service/payment-service";
import { toast } from "react-toastify";
import CurrencyAmountInput from "../CurrencyAmountInput";
import DatePicker from "../Common/Component/DatePicker";
import { useTranslation } from "react-i18next";

export default function AddPay({ show, onHide, getList }) {
    const { t } = useTranslation();
    const [date, setDate] = useState(() => new Date().toISOString().split("T")[0]);
    const [amount, setAmount] = useState("");
    const [type, setType] = useState(""); // payin / payout
    const [note, setNote] = useState("");
    const { setLoading } = useLoader();
    const { currentLab } = useLab()
    const [selectedPaymentCurrency, setSelectedPaymentCurrency] = useState(currentLab.baseCurrency);

    // Validation errors
    const [errors, setErrors] = useState({});

    const handleSubmit = async () => {
        const newErrors = {};
        if (!amount || Number(amount) <= 0) {
            newErrors.amount = t("Amount is required and must be greater than 0.");
        }

        if (!type) {
            newErrors.type = t("Please select Pay-In or Pay-Out.");
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;   // ← EARLY RETURN

        setLoading(true);
        try {
            const form_data = new FormData();
            form_data.append("amount", amount);
            // form_data.append("currencyType", currentLab?.baseCurrency);
            form_data.append("reason", note);
            form_data.append("type", type);
            form_data.append("currencyType", selectedPaymentCurrency);
            form_data.forEach((key, value) => console.log(value + " :" + key))
            let res;

            if (type === "payin") {
                res = await paymentIn(form_data);
            } else {
                res = await paymentOut(form_data);
            }

            if (res.data.success) {
                toast.success(res.data.message);
                onHide();
                setAmount("");
                setType("");
                setNote("");
                getList();
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} scrollable centered enforceFocus={false}>
                <Modal.Header closeButton className="py-2 px-3 border-bottom">
                    <Modal.Title className="fs-6 fw-semibold m-0">{t("Paid-In Paid-Out")}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-2 px-3">
                    <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                        {/* Date */}
                        <Form.Group className="mb-2">
                            <Form.Label className="form-label mb-1" style={{ fontSize: "12.5px", fontWeight: 500 }}>
                                {t("Date")}
                            </Form.Label>
                            <DatePicker
                                name="date"
                                value={date}
                                onChange={(event) => setDate(event.target.value || "")}
                            />
                        </Form.Group>

                        {/* Amount */}
                        <Form.Group className="mb-2">
                            <Form.Label className="form-label mb-1" style={{ fontSize: "12.5px", fontWeight: 500 }}>
                                {t("Amount")}{" "}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="d-flex">
                                <input
                                    type="number"
                                    placeholder={t("Enter Amount")}
                                    className={`form-control rounded-start ${errors.amount ? "is-invalid" : ""}`}
                                    value={amount}
                                    onChange={(e) => {
                                        setAmount(e.target.value);
                                        if (errors.amount) {
                                            setErrors((prev) => ({ ...prev, amount: "" }));
                                        }
                                    }}
                                    style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px', height: '36px', fontSize: '13px' }}
                                />
                                <select
                                    onChange={(e) => {
                                        setSelectedPaymentCurrency(e.target.value);
                                    }}
                                    value={selectedPaymentCurrency}
                                    className="form-select rounded-end"
                                    style={{ width: '130px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', height: '36px', fontSize: '13px' }}
                                >
                                    {currentLab.allowedCurrencies.map((cur) => (
                                        <option key={cur} value={cur}>
                                            {cur}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {errors.amount && (
                                <div className="text-danger mt-1" style={{ fontSize: "11px" }}>
                                    {errors.amount}
                                </div>
                            )}
                        </Form.Group>

                        {/* Pay-in / Pay-out */}
                        <Form.Group className="mb-2">
                            <Form.Label className="form-label mb-1" style={{ fontSize: "12.5px", fontWeight: 500 }}>
                                {t("Type")}{" "}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="d-flex gap-3 mt-1">

                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-payin"
                                        type="radio"
                                        name="paytype"
                                        value="payin"
                                        checked={type === "payin"}
                                        onChange={(e) => {
                                            setType(e.target.value);
                                            if (errors.type) {
                                                setErrors((prev) => ({ ...prev, type: "" }));
                                            }
                                        }}
                                    />
                                    <Label for="customer-payin" className="mb-0 pe-2" style={{ fontSize: "13px" }}>
                                        {t("Paid In")}
                                    </Label>
                                </div>

                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-payout"
                                        type="radio"
                                        name="paytype"
                                        value="payout"
                                        checked={type === "payout"}
                                        onChange={(e) => {
                                            setType(e.target.value);
                                            if (errors.type) {
                                                setErrors((prev) => ({ ...prev, type: "" }));
                                            }
                                        }}
                                    />
                                    <Label for="customer-payout" className="mb-0 pe-2" style={{ fontSize: "13px" }}>
                                        {t("Paid Out")}
                                    </Label>
                                </div>
                            </div>
                            {errors.type && (
                                <div className="text-danger mt-1" style={{ fontSize: "11px" }}>{errors.type}</div>
                            )}
                        </Form.Group>

                        {/* Note */}
                        <Form.Group className="mb-0">
                            <Form.Label className="form-label mb-1" style={{ fontSize: "12.5px", fontWeight: 500 }}>
                                {t("Note")}
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder={t("Write note (optional)")}
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                style={{ fontSize: "13px", resize: "vertical" }}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="py-2 px-3 border-top d-flex justify-content-end gap-2">
                    <Button variant="primary" size="sm" className="px-3" onClick={handleSubmit}>
                        {t("Submit")}
                    </Button>
                    <Button variant="secondary" size="sm" className="px-3" onClick={onHide}>
                        {t("Close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
